export const getters = {
  uiFlagsIn: state => portalId => {
    const uiFlags = state.portals.uiFlags.byId[portalId];
    if (uiFlags) return uiFlags;
    return { isFetching: false, isUpdating: false, isDeleting: false };
  },

  isFetchingPortals: state => state.uiFlags.isFetching,
  portalBySlug:
    (...getterArguments) =>
    portalId => {
      const [state] = getterArguments;
      const portal = state.portals.byId[portalId];

      return portal;
    },
  allPortals: (...getterArguments) => {
    const [state, _getters] = getterArguments;
    const portals = state.portals.allIds.map(id => {
      return _getters.portalBySlug(id);
    });
    return portals;
  },
  getPortals: (...getterArguments) => {
    const [state, _getters] = getterArguments;
    return _getters.allPortals;
  },
  getPortalBySlug: (...getterArguments) => slug => {
    const [state, _getters] = getterArguments;
    const portals = _getters.allPortals;
    return portals.find(portal => portal.slug === slug);
  },
  count: state => state.portals.allIds.length || 0,
  getMeta: state => state.meta,
};
